import axiosInstance from "../../../api/axiosConfig";

export const getCustomers = (params: any) => {
  return axiosInstance.get("/admin/companies", {
    params: params,
  });
};

export const deleteCustomer = (id: string) => {
  return axiosInstance.delete(`/admin/companies/${id}`);
};
